import { useContext, type FC } from 'react';
import { ModelVolatilitySurfaceProps } from './types';
import './model-volatility-surface-styles.scss';

import Chart from '../../chart';
import { useProcessSurfaceData } from './hooks/use-process-surface-data';
import { ModelVolatilitySurfaceContext } from '../../../../providers/model-volatility-surface-provider';
import TimestampInfo from '../../timestamp-info';
import { useHardwareAcceleration } from '../../../../hooks/use-hardware-acceleration';
import NoWebGLPlaceholder from './no-webgl-placeholder';

const ModelVolatilitySurfaceContent: FC<ModelVolatilitySurfaceProps> = () => {
  const { data, timestamp } = useContext(ModelVolatilitySurfaceContext);
  const { isWebGLAvailable } = useHardwareAcceleration();

  const { config3D } = useProcessSurfaceData(data?.tenors || null);

  return (
    <div className="model-volatility-surface-content">
      <div className="model-volatility-surface-timestamp">
        <TimestampInfo timestamp={new Date(timestamp).getTime()} keepLocalTime />
      </div>
      {!isWebGLAvailable() ? <NoWebGLPlaceholder /> : <Chart {...config3D} useGL />}
    </div>
  );
};
export default ModelVolatilitySurfaceContent;
